export enum PROGRESS_BAR_STATES {
	INITIAL = 0,
	QUARTER = 25,
	MIDDLE = 50,
	QUARTER_AND_HALF = 75,
	ALMOST_COMPLETE = 95,
	COMPLETE = 100,
}
